
import React from 'react';
import NavBar from '@/components/layout/NavBar';
import Footer from '@/components/layout/Footer';
import ProductList from '@/components/products/ProductList';
import SecuritySection from '@/components/products/SecuritySection';
import ComparisonCTA from '@/components/products/ComparisonCTA';
import FadeInSection from '@/components/ui/FadeInSection';
import SEO from '@/components/seo/SEO';

const Products = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Keystle Products - Identity Management Solutions"
        description="Discover Keystle's comprehensive identity management products for workforce identity, business identity, and customer identity access management."
        canonicalPath="/products" 
        keywords="identity management products, workforce IAM, business IAM, CIAM, authentication solutions"
      />
      <NavBar />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-6">
          <FadeInSection>
            <ProductList />
          </FadeInSection>
          
          <FadeInSection delay={200}>
            <ComparisonCTA />
          </FadeInSection>
          
          <FadeInSection delay={300}>
            <SecuritySection />
          </FadeInSection>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Products;
